// extracted by mini-css-extract-plugin
module.exports = {"grid":"StageDisplay_grid__1F4_r","stage":"StageDisplay_stage__awkHT","stageHighlight":"StageDisplay_stageHighlight__3axQf"};